import * as z from "zod/v4";

export const deleteMasonhubIntegration = {
  name: "deleteMasonhubIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
